export default {
  /**
   * @param dispatch
   * @param text
   */
  show(dispatch, text) {
    dispatch('app/showSnackbar', { text, color: 'black' }, { root: true });
  },

  /**
   * @param dispatch
   * @param text
   */
  success(dispatch, text) {
    dispatch('app/showSnackbar', { text, color: 'success' }, { root: true });
  },

  /**
   * @param dispatch
   * @param text
   */
  error(dispatch, text) {
    dispatch('app/showSnackbar', { text, color: 'error' }, { root: true });
  },
};



// WEBPACK FOOTER //
// ./src/services/snackbar-service.js